module.exports = __webpack_public_path__ + "static/logo29-ba1cb9dfc4a152aed53ac7424571908e.png";